import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  Content,
  PageTitle,
  PanelColumn,
  PageHeadingArea,
  PanelColumnSet,
} from "@backslashbuild/pp-ui";

import AgencyAccountOwnerForm from "../modules/agencies/AgencyAccountOwnerForm";

export default function Agency() {
  const { id } = useParams();

  return (
    <Content scrollable>
      <PageHeadingArea>
        <PageTitle>Edit Agency Details</PageTitle>
      </PageHeadingArea>

      <PanelColumnSet>
        <PanelColumn>
          <AgencyAccountOwnerForm id={id} />
        </PanelColumn>
      </PanelColumnSet>
    </Content>
  );
}
